<template>
  <div>
    <div class="number_title title_margin" style="margin:15px 0">
      <span
        v-if="item.value.digitalAttribute.fill"
        style="position:relative; padding: 0 5px;"
        :class="{'star':item.value.digitalAttribute.fill}"
      ></span>
      {{(parseInt(pindex) + 1) + '.'}}
      {{item.value.digitalAttribute.name}}
      <!-- <span v-if="item.value.digitalAttribute.unit != ''">(单位:{{item.value.digitalAttribute.unit}})</span> -->
      <!-- <span v-if="item.value.digitalAttribute.numberQuantityAfterPoint != ''">(保留:{{item.value.digitalAttribute.numberQuantityAfterPoint}}位小数)</span> -->
      <span
        v-if="item.value.digitalAttribute.minValue || item.value.digitalAttribute.maxValue"
      >{{maxMinPlace}}</span>
      <!-- 文件附件 -->
      <file
        style="display:inline;"
        v-if="item.value.digitalAttribute.imageUrls.length != '0'"
        :item="item"
      ></file>
    </div>

    <div class="info_message">{{item.value.digitalAttribute.prompt}}</div>
    <div style="position: relative;">
      <!-- <i class="iconfont icon-shuzi"></i> -->
      <InputNumber
        style="width: 200px;"
        type="number"
        :max="Number(item.value.digitalAttribute.maxValue)"
        :min="Number(item.value.digitalAttribute.minValue)"
        v-model.number="item.value.digitalAttribute.answer"
        :placeholder="fillBlankPlaceholder + minWordQuantity + maxWordQuantity"
        @on-change="digtalQuestion(item, item.value.digitalAttribute.answer)"
        class="digtal_bgc"
      ></InputNumber>
      <!--  -->
    </div>
    <div v-if="item.value.digitalAttribute.desc">
      <div
        style="color:#3a7bed;margin-top:10px"
        v-if="item.value.digitalAttribute.isNormal == '1'"
      >{{item.value.digitalAttribute.desc}}</div>
      <div
        style="color:rgba(255, 91, 96, 1);margin-top:10px"
        v-else
      >{{item.value.digitalAttribute.desc}}</div>
    </div>
  </div>
</template>
<script>
import file from './file'
export default {
  props: ['item', 'pindex'],
  data() {
    return {
      fillBlankPlaceholder: '',
      minWordQuantity: '',
      maxWordQuantity: '',
      maxMinPlace: '',
    }
  },
  created: function () {
    this.fillBlankPlaceholder = this.item.value.digitalAttribute.defaultValue
      ? this.item.value.digitalAttribute.defaultValue
      : ''
    if (this.item.value.digitalAttribute.numberQuantityAfterPoint) {
      if (
        this.item.value.digitalAttribute.minValue &&
        this.item.value.digitalAttribute.maxValue
      ) {
        this.maxMinPlace =
          '(请输入' +
          this.preFix(
            this.item.value.digitalAttribute.minValue,
            this.item.value.digitalAttribute.numberQuantityAfterPoint
          ) +
          '至' +
          this.preFix(
            this.item.value.digitalAttribute.maxValue,
            this.item.value.digitalAttribute.numberQuantityAfterPoint
          ) +
          '之间的数字)'
      } else if (
        this.item.value.digitalAttribute.minValue &&
        !this.item.value.digitalAttribute.maxValue
      ) {
        this.maxMinPlace =
          '(请输入' +
          this.preFix(
            this.item.value.digitalAttribute.minValue,
            this.item.value.digitalAttribute.numberQuantityAfterPoint
          ) +
          '及以上的数字)'
      } else if (
        !this.item.value.digitalAttribute.minValue &&
        this.item.value.digitalAttribute.maxValue
      ) {
        this.maxMinPlace =
          '(请输入' +
          this.preFix(
            this.item.value.digitalAttribute.maxValue,
            this.item.value.digitalAttribute.numberQuantityAfterPoint
          ) +
          '及以下的数字)'
      }
    } else {
      if (
        this.item.value.digitalAttribute.minValue &&
        this.item.value.digitalAttribute.maxValue
      ) {
        this.maxMinPlace =
          '(请输入' +
          this.item.value.digitalAttribute.minValue +
          '至' +
          this.item.value.digitalAttribute.maxValue +
          '之间的数字)'
      } else if (
        this.item.value.digitalAttribute.minValue &&
        !this.item.value.digitalAttribute.maxValue
      ) {
        this.maxMinPlace =
          '(请输入' +
          this.item.value.digitalAttribute.minValue +
          '及以上的数字)'
      } else if (
        !this.item.value.digitalAttribute.minValue &&
        this.item.value.digitalAttribute.maxValue
      ) {
        this.maxMinPlace =
          '(请输入' +
          this.item.value.digitalAttribute.maxValue +
          '及以下的数字)'
      }
    }
  },
  watch: {
    item: {
      handler(val) {
        // console.log(val)
      },
      deep: true,
    },
  },
  methods: {
    preFix: function (info, decima) {
      // console.log(decima);
      // 判断是否有小数点
      var dot = info.toString().indexOf('.')
      // console.log(dot)
      var num = 0
      // 有小数点
      if (info) {
        if (dot > -1) {
          // 判断有几位小数点
          num = info.toString().split('.')[1].length

          if (Number(num) !== Number(decima)) {
            // console.log(Number(num));
            // console.log(Number(decima));
            for (var i = 0; i < Number(decima) - Number(num); i++) {
              info = info + '0'
            }
            // console.log(info);
          }
        } else {
          if (decima) {
            info = info + '.'
            for (var i = 0; i < Number(decima); i++) {
              info = info + '0'
            }
          } else {
            info = info
          }
        }
      }
      return info
    },
    // 数字验证 data.value.digitalAttribute.errorMessage != "" ||
    digtalQuestion: function (data, val) {
      // 判断是否有小数点
      if (val.toString().indexOf('.') != -1) {
        // 获取小数点位数
        this.pointSpot = val.toString().split('.')[1].length
      } else {
        this.pointSpot = 0
      }
      data.value.digitalAttribute.verifyStatus = true
      if (this.pointSpot > 0) {
        var newVal = Number(val.toString().split('.')[0]) + 1
      } else {
        var newVal = val
      }
      // console.log(val)

      if (
        data.value.digitalAttribute.minValue &&
        Number(val) < Number(data.value.digitalAttribute.minValue)
      ) {
        this.item.value.digitalAttribute.answer =
          data.value.digitalAttribute.minValue
        this.$Message.warning(
          data.value.digitalAttribute.errorMessage != ''
            ? data.value.digitalAttribute.errorMessage
            : '最小值' + data.value.digitalAttribute.minValue
        )
        data.value.digitalAttribute.verifyStatus = false
      } else if (
        data.value.digitalAttribute.maxValue &&
        Number(newVal) >= Number(data.value.digitalAttribute.maxValue) + 1
      ) {
        this.item.value.digitalAttribute.answer =
          data.value.digitalAttribute.maxValue
        this.$Message.warning(
          data.value.digitalAttribute.errorMessage != ''
            ? data.value.digitalAttribute.errorMessage
            : '最大值' + data.value.digitalAttribute.maxValue
        )
        data.value.digitalAttribute.verifyStatus = false
        //  data.value.digitalAttribute.answer=""
      } else if (
        data.value.digitalAttribute.numberQuantityAfterPoint != '' &&
        this.pointSpot >
          Number(data.value.digitalAttribute.numberQuantityAfterPoint)
      ) {
        // this.item.value.digitalAttribute.answer =  val.toString().split('.')[0] +  val.toString().split('.')[1].splice(0,1)
        this.$Message.warning(
          data.value.digitalAttribute.errorMessage != ''
            ? data.value.digitalAttribute.errorMessage
            : '保留小数点' +
                data.value.digitalAttribute.numberQuantityAfterPoint +
                '位'
        )
        data.value.digitalAttribute.verifyStatus = false
      }
    },
  },
  components: {
    file,
  },
  watch: {
    item: {
      handler(val, oldval) {
        // console.log(val);
      },
      deep: true,
    },
  },
}
</script>
<style lang="less">
.star::after {
  position: absolute;
  top: -3px;
  left: 0;
  content: '*';
  color: #e64340;
  font-size: 20px;
}
.digital {
  height: 33px;
  border: 1px solid rgb(220, 220, 220);
  border-radius: 5px;
  padding-left: 10px;
  box-sizing: border-box;
  background-color: rgb(246, 248, 252);
}
.border-bottom-1px:after {
  border: none;
}
.digitalHover {
  border: 2px solid #ffd07f;
}
.digital .icon-shuzi {
  width: 10%;
  position: absolute;
  margin-top: 5px;
}
.digital .digtal_bgc {
  height: 100%;
  width: 200px;
  outline: none;
  background-color: rgb(246, 248, 252);
  padding-left: 20px;
}
</style>


